import { render, staticRenderFns } from "./left_1.vue?vue&type=template&id=0ebb28b2&scoped=true&"
import script from "./left_1.vue?vue&type=script&lang=js&"
export * from "./left_1.vue?vue&type=script&lang=js&"
import style0 from "./left_1.vue?vue&type=style&index=0&id=0ebb28b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb28b2",
  null
  
)

export default component.exports